/**
 * Authentication-related constants
 * Centralized location for all auth paths and metadata keys to avoid magic strings
 */

// Auth route paths
export const AUTH_PATHS = {
  SIGNIN: "/auth/signin",
  SIGNUP: "/auth/signup",
  UPDATE: "/auth/update",
  CALLBACK: "/auth/callback",
} as const;

/** Public marketing waitlist (no auth). */
export const WAITLIST_PATH = "/waitlist" as const;

// User metadata keys
export const USER_METADATA_KEYS = {
  PASSWORD_RESET_REQUIRED: "password_reset_required",
} as const;

export enum AuthMachineStatus {
  BOOTING = "booting",
  UNAUTHENTICATED = "unauthenticated",
  EXPIRED = "expired",
  AUTHENTICATED = "authenticated",
  PASSWORD_RESET_PENDING = "passwordResetPending",
}
